<template>
  <TimeOffReport :timeOffReportUserId="currentUserId || timeOffReportUserId" :isPage="isPage" :timeOffReportUser="timeOffReportUser" :hideMonthsSection="hideMonthsSection" :breadcrumbs="breadcrumbs" @close="$emit('close')"/>
</template>

<script>
import TimeOffReport from './TimeOffReport.vue'

export default {
  name: 'TimeOffReportById',
  components: {
    TimeOffReport
  },
  props: {
    isPage: {
      type: Boolean,
      default: true
    },
    timeOffReportUserId: {
      type: Number,
      default: null
    },
    timeOffReportUser: {
      type: Object
    },
    hideMonthsSection: {
      type: Boolean,
      default: false
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  emits: ['close'],
  data () {
    return {
      currentUserId: null
    }
  },
  created () {
    this.updateUserId()
  },
  watch: {
    '$route.params.id' () {
      this.updateUserId()
    }
  },
  methods: {
    updateUserId () {
      this.currentUserId = this.$route.params.id ? parseInt(this.$route.params.id) : null
    }
  }
}
</script>
